import { useContext } from 'react';
import { NotificationContext } from './context';
export var useNotifications = function useNotifications() {
  var _useContext = useContext(NotificationContext),
      notifications = _useContext.notifications;

  return notifications;
};
export var useNotificationActions = function useNotificationActions() {
  var _useContext2 = useContext(NotificationContext),
      pushNotification = _useContext2.pushNotification,
      removeNotification = _useContext2.removeNotification;

  return {
    pushNotification: pushNotification,
    removeNotification: removeNotification
  };
};